import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../button/Button";
import "./SourceActionsMenu.scss";
import { useTranslation } from "react-i18next";
import { DhcpdConfigServer } from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons";
import UserfulTooltip from "../../Widgets/UserfulTooltip";

interface IProps {
    value: DhcpdConfigServer;
    onEdit: (dhcp: DhcpdConfigServer) => void;
}

export default function DHCPMenu(props: IProps) {
    const { t } = useTranslation();

    return (
        <UserfulTooltip title={t("Shared.edit")}>
            <Button
                disabled={!props.value.enabled}
                iconOnly
                onClick={(e) => {
                    e.stopPropagation();
                    props.onEdit(props.value);
                }}
                className="source-actions-menu-toggle"
                variant={"ghost"}
            >
                <FontAwesomeIcon icon={faPenToSquare} />
            </Button>
        </UserfulTooltip>
    );
}
